import React from 'react';
import Cookies from 'js-cookie';
import DashBoardNavBar from '../components/DashBoardNavBar.tsx';
import Navbar from '../components/Navbar.tsx';
import { Particles } from '../components/Particles.tsx';
import AimTesterGame from "../components/AimTesterGame.tsx";

const AimTester: React.FC = () => {
  const isAuthenticated = !!Cookies.get('token'); // Ellenőrzi, hogy van-e token a cookie-ban

  return (
    <div style={{ position: 'relative', minHeight: '100vh' }}>
      {/* Particles komponens a háttérben */}
      <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: -1 }}>
        <Particles />
      </div>
      
      {/* Navigációs sávok és egyéb tartalom */}
      {isAuthenticated ? <DashBoardNavBar /> : <Navbar />}
      <AimTesterGame />
    </div>
  );
};

export default AimTester;
